import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { basePageWrap } from '../BasePage';
import styles from './EventSubmissionPage.module.scss';

import EventSubmissionFormV2 from "../../components/EventSubmissionFormV2";

import {
    GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3';

class EventSubmissionPage extends PureComponent {
    state = {};

    static defaultProps = {
        articleEntry: {},
        articleHero: null,
        extendedByline: null,
        richText: null,
        extendedRichText: [],
        csrf: '',
    };

    static propTypes = {
        articleEntry: PropTypes.object.isRequired,
        articleHero: PropTypes.object,
        extendedByline: PropTypes.object,
        richText: PropTypes.object,
        extendedRichText: PropTypes.array,
    };

    render() {
        const {
            csrf,
            texts,
            categories,
            contactUsBox,
            venueOptions
        } = this.props;
        
        return (
            <div className={styles['EventSubmissionPage']}>
                <div className={styles['EventSubmissionPage__Main']}>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                    >
                        <EventSubmissionFormV2
                            texts={texts}
                            categories={categories}
                            contactUsBox={contactUsBox}
                            csrf={csrf}
                            venueOptions={venueOptions}
                        />
                    </GoogleReCaptchaProvider>
                </div>
            </div>
        );
    }
}

export default basePageWrap(EventSubmissionPage);
